//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import colors from 'components/utils/colors'
import ToggleSwitch from 'components/Shared/ToggleSwitch/Index'

const StyledWrapper = styled.div`
  display: flex;
  font-size: 14px;
  gap: 8px;
  padding-top: 50px;
  color: ${colors.secondary20};
`

const ClickableLabel = styled.span`
  cursor: pointer;
  user-select: none;
  &:hover {
    color: ${colors.contentPrimaryHover};
  }
`

const ReadOnlyFieldsToggler = ({ value, onChange }) => {
  const { t } = useTranslation()

  const toggle = () => {
    onChange(!value)
  }

  return (
    <StyledWrapper>
      <ToggleSwitch
        value={value}
        onChange={(event) => onChange(!(event.target.value === 'true'))}
      />
      <ClickableLabel onClick={toggle}>
        {t('ticketPage.hideReadOnlyFields')}
      </ClickableLabel>
    </StyledWrapper>
  )
}

ReadOnlyFieldsToggler.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func,
}

export default ReadOnlyFieldsToggler
